import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Chat Layout Overhaul",
  published_at: "2026-03-04",
  summary: "A new multi-pane layout, expandable tables, and smoother navigation make the AI chat easier to work in.",
  tags: ["Platform"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "This release introduces a redesigned three-panel chat workspace. Conversation, files, and source material stay visible side by side so you can reference citations without losing context. The sidebar rail gives you one-click access to files, playbooks, and citations, and you can open multiple tabs, switch between them, and refresh without losing your layout."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "7d66e295-b325-4b58-9c78-9ff7a5392a2c"
    }), "\n", _jsx(_components.p, {
      children: "Assistant-generated tables now include an expand button that opens a larger, scrollable view with pinned headers and wrapped cell content, making long compliance checklists much easier to review."
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Performance (1)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Search result highlights appear more quickly when browsing opportunities and documents"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "UX (2)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Search for teammates by name when sharing a chat session"
        }), "\n", _jsx(_components.li, {
          children: "Playbook content no longer spills outside its text area when viewing details"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Reliability (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Fixed opening a source reference causing the chat to jump"
        }), "\n", _jsx(_components.li, {
          children: "Fixed documents getting stuck during shredding and not being re-processable"
        }), "\n", _jsx(_components.li, {
          children: "Fixed compliance checklist exports missing items in some cases"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
